export default {
  // Authentication

  RegistrationScreen: {
    title: "Registrierung",
    loginHint: "Sie haben sich bereits registriert? Zum ",
    personHeading: "Angaben zur Person",
    emailPlaceholder: "meine@email.at",
    phoneNumberPlaceholder: "+43 123 4567890",
    landLinePhoneNumberPlaceholder: "+43 3141 1234",
    companyHeading: "Angaben zur Firma",
    uidNumberPlaceholder: "ATU12345678 oder 72-999/9722",
    termsOfServicePartOne: "Ich habe die",
    tos: "Geschäftsbedingungen",
    termsOfServicePartTwo: "gelesen und stimme diesen zu.",
    submitLabel: "Registrieren",

    successRegisterMessage:
      'Die Firma "{{name}}" wurde erfolgreich registriert.',
    successResendActivationMessage:
      'Eine erneute Aktivierungsmail wurde an folgende E-Mail-Adresse "{{email}}" versendet.',
  },

  ManagerLoginScreen: {
    title: "Anmeldung",
    explanationText:
      "Wenn Ihr Unternehmen bereits registriert ist, " +
      "dann können Sie dieses Gerät mit einer Kasse verknüpfen.",
    companyEmail: "Unternehmer-E-Mail",
    companyPassword: "Unternehmer-Passwort",
    pairDevice: "Gerät verknüpfen",
    registrationHintStart: "Neu hier? ",
    registrationLinkLabel: "Registrieren",
    registrationHintEnd: " Sie sich bitte!",
    forgotPassword: "Passwort vergessen?",
    registerHint: "Ihr Unternehmen noch nicht registriert?",
    register: "Registrieren",
    chooseABackend: "Wählen Sie ein System aus...",
    pairingInProgress: "Gerät wird verknüpft...",
    unknownDevice: "Unbekanntes Gerät",

    errorPairingTitle: "Fehler beim Verknüpfen der Kasse",
    noUnpairedCashRegisterDialogTitle: "Sie haben keine freien Kassen mehr!",
    getInContact: "Kontakt aufnehmen",
    contactUs: "Kontaktieren Sie uns gerne!",

    confirmEmail:
      "Bitte bestätigen Sie Ihre E-Mail-Adresse, bevor Sie versuchen, sich einzuloggen.\n" +
      "Überprüfen Sie bitte zusätzlich den Spam-Ordner Ihres Postfaches.",
    resendActivationEmail: "Aktivierungsmail erneut versenden",
    emailConfirmed: "Ihre Registrierung wurde erfolgreich bestätigt.",

    assumeCompanySelectionTitle:
      "Mit welcher Firma soll dieses Gerät verknüpft werden?",
  },

  // Printer

  BluetoothPrinterScreen: {
    title: "Druckerkonfiguration",
    displayName: "Anzeigename",
    cutter: "Papierabschneider",
    printingWidth: "Druckbreite",
    chooseAPrintingWidth: "Wählen Sie eine Druckbreite aus...",

    printerTooltip:
      "Aktivieren Sie dieses Kontrollkästchen, wenn Sie möchten, " +
      "dass weitere Ausdrucke mit Hilfe dieses Druckers erstellt werden sollen.",
    cutterTooltip:
      "Aktivieren Sie dieses Kontrollkästchen, " +
      "wenn ihr Bondrucker das automatische Abtrennen des Papiers unterstützt.",

    connectPrinter: "Drucker verbinden",
    connectingWithDevice: "Verbinde mit Gerät...",
    defaultPrinter: "Standarddrucker",
    removePrinter: "Drucker entfernen",

    printSample: "Drucker testen",
    thatIsATestPrint: "Dies ist ein Testdruck",
    printingWith: "Auf einem Drucker namens {{name}}",
    determiningWidth: "Bestimme Druckbreite...",
    printingWidthText:
      "Bitte stellen Sie die größte Druckbreite ein, bei der die Zeile noch nicht umgebrochen wird.",

    successEditMessage: 'Der Drucker "{{name}}" wurde erfolgreich bearbeitet.',
  },

  // Contacts

  ContactListScreen: {
    referenceData: "Stammdaten",
    clientNumber: "Kundennummer",
    additional: "Zusatz",
    text: "Text",
    printOnReceipt: "Text übernehmen",
    receiptTextAdaption: "Übernahme",
    periodOfCashback: "Zahlungsziel",
    periodOfCashbackDiscount: "Skonto",
    periodOfCashbackDiscountInPercent: "Skonto in %",
    clientDiscount: "Kundenrabatt",
    clientDiscountInPercent: "Rabatt in %",
    nameOfBank: "Name der Bank",
    iban: "IBAN",
    bic: "BIC",
    contactList: "Kundenliste",
    contactType: "Adresstyp",
    currentMonthTurnover: "Derzeitiger Monatsumsatz",
    currentYearTurnover: "Derzeitiger Jahresumsatz",
    totalTurnover: "Gesamter Umsatz",
    supplier: "Lieferant",
    clientSupplier: "Kunde & Lieferant",
    billingAddress: "Rechnungsadresse",
    bankingDetails: "Bankdaten",
    financialTerms: "Konditionen",
    turnoverOverview: "Umsatzübersicht",
    ibanPlaceholder: "AT12 3456 7890 1234 5678",
    bicPlaceholder: "ABCD AD A1 B34",
    enableTurnoverFilters: "Umsatzfilter aktivieren",

    receiptTextTooltip:
      "Die angegebene Bemerkung wird für Belege mit Kundenzuordnung automatisch vorgeschlagen.",
    emptyListMessage:
      "Es sind noch keine Kunden vorhanden. Bitte legen Sie einen Kunden an.",
    emptyTableMessage:
      "Es wurden keine Kunden zu diesen Filterkriterien gefunden.",

    sendByMailDialogTitle: "Kundenliste per E-Mail versenden",
    successSendMessage: 'Die Kundenliste wurde an "{{email}}" versendet.',

    deleteDialogTitle: "Kunde löschen",
    deleteDialogMessage: 'Möchten Sie den Kunden "{{name}}" wirklich löschen?',
    successDeleteMessage: 'Der Kunde "{{name}}" wurde erfolgreich gelöscht.',
  },
  ContactAddScreen: {
    title: "Kunde anlegen",

    successAddMessage: 'Der Kunde "{{name}}" wurde erfolgreich angelegt.',
  },
  ContactEditScreen: {
    title: "Kunde bearbeiten",

    successEditMessage: 'Der Kunde "{{name}}" wurde erfolgreich bearbeitet.',
  },

  DepartmentListScreen: {
    title: "Abteilungen",

    emptyListMessage:
      "Es sind noch keine Abteilungen vorhanden. Bitte legen Sie eine Abteilung an.",
    emptyTableMessage:
      "Es wurden keine Abteilungen zu diesem Suchbegriff gefunden.",

    deleteDialogTitle: "Abteilung löschen",
    deleteDialogMessage:
      'Möchten Sie die Abteilung "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Abteilung "{{name}}" wurde erfolgreich gelöscht.',
  },
  DepartmentAddScreen: {
    title: "Abteilung anlegen",

    successAddMessage: 'Die Abteilung "{{name}}" wurde erfolgreich angelegt.',
  },
  DepartmentEditScreen: {
    title: "Abteilung bearbeiten",

    successEditMessage:
      'Die Abteilung "{{name}}" wurde erfolgreich bearbeitet.',
  },

  PersonInChargeListScreen: {
    title: "Ansprechpartner",

    emptyListMessage:
      "Es sind noch keine Ansprechpartner vorhanden. Bitte legen Sie einen Ansprechpartner an.",
    emptyTableMessage:
      "Es wurden keine Ansprechpartner zu diesem Suchbegriff gefunden.",

    deleteDialogTitle: "Ansprechpartner löschen",
    deleteDialogMessage:
      'Möchten Sie den Ansprechpartner "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Der Ansprechpartner "{{name}}" wurde erfolgreich gelöscht.',
  },
  PersonInChargeAddScreen: {
    title: "Ansprechpartner anlegen",

    successAddMessage:
      'Der Ansprechpartner "{{name}}" wurde erfolgreich angelegt.',
  },
  PersonInChargeEditScreen: {
    title: "Ansprechpartner bearbeiten",

    successEditMessage:
      'Der Ansprechpartner "{{name}}" wurde erfolgreich bearbeitet.',
  },

  ShippingAddressListScreen: {
    title: "Lieferadressen",

    emptyListMessage:
      "Es sind noch keine Lieferadressen vorhanden. Bitte legen Sie eine Lieferadresse an.",
    emptyTableMessage:
      "Es wurden keine Lieferadressen zu diesem Suchbegriff gefunden.",

    deleteDialogTitle: "Lieferadresse löschen",
    deleteDialogMessage:
      'Möchten Sie die Lieferadresse "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Lieferadresse "{{name}}" wurde erfolgreich gelöscht.',
  },
  ShippingAddressAddScreen: {
    title: "Lieferadresse anlegen",

    successAddMessage:
      'Die Lieferadresse "{{name}}" wurde erfolgreich angelegt.',
  },
  ShippingAddressEditScreen: {
    title: "Lieferadresse bearbeiten",

    successEditMessage:
      'Die Lieferadresse "{{name}}" wurde erfolgreich bearbeitet.',
  },

  // Receipts

  ReceiptListScreen: {
    title: "Belegübersicht",
    clientTitle: "Kundenbelege",
    createZeroReceipt: "Nullbeleg erstellen",
    filterAfter: "Filtern nach {{name}}",
    receiptList: "Belegliste",
    receiptsExport: "Belegexport",

    a4DetailedExportTooltip:
      "Um die Exportzeit zu reduzieren, werden A4-Belege ohne Belegdesigns exportiert.",
    emptyListMessage: "Es sind keine Belege für diesen Zeitraum vorhanden.",
    emptyTableMessage: "Es wurden keine Belege zu diesem Suchbegriff gefunden.",

    sendByMailDialogTitle: "Belegliste per E-Mail versenden",
    successSendMessage: 'Die Belegliste wurde an "{{email}}" versendet.',
  },
  ReceiptDetailsScreen: {
    receipt: "Beleg",
    receiptFrom: "Beleg vom {{date}}",
    receiptVoid: "Belegstorno",
    refunded: "GUTSCHRIFTSERSTELLUNG",
    refundedSmall: "GE",
    cancelled: "STORNO",
    cancelledSmall: "ST",
    refund: "GUTSCHRIFT",
    refundSmall: "GS",
    cancelRefund: "STORNO-GUTSCHRIFT",
    cancelRefundSmall: "ST-GS",
    cancelledBy: "Storniert durch",
    refundedBy: "Gutgeschrieben durch",
    refundedFor: "Gutschrift für",
    given: "Gegeben",
    moneyAmountReturned: "Rückgeld",
    vatIncluded: "Enthaltene MwSt.",
    vatShort: "MwSt.",
    hobexTransaction: "Hobex Transaktion",
    gpTomTransaction: "GP tom Transaktion",
    transactionTime: "Transaktionszeit",
    receiptNumberShort: "Beleg-Nr.",
    europayAppId: "App-ID",
    batchNumber: "Abschlussnummer",
    terminalId: "Terminal-ID",
    cardIssuer: "Kartenherausgeber",
    cardNumber: "Kartennummer",
    transactionType: "Transaktionstyp",
    authorizationCode: "Authorisierungscode",
    sequenceNumber: "Sequenznummer",
    responseCode: "Antwortcode",
    articleTotal: "Warensumme",
    discountTotal: "Rabattsumme",
    servedByOperator: "Es bediente Sie",
    taxOfficeCashBoxId: "Kassen-ID: {{taxOfficeCashBoxId}}",
    signatureDeviceFailed: "Signatureinheit ausgefallen.",
    reprintReceipt: "Beleg nachdrucken",
    createRefund: "Gutschrift erstellen",
    changeContact: "Kunde anpassen",

    // Should rather be located in ReceiptListScreen,
    // but for convenience reasons, keep it here (Receipts - commands).
    zeroReceiptSuccess: "Ein Nullbeleg wurde erfolgreich erstellt.",

    outputCashAmount:
      "Bitte geben Sie den Betrag in der Höhe von {{moneyAmount}} in Bar aus.",
    outputVoucherAmount:
      "Bitte geben Sie den Betrag in der Höhe von {{moneyAmount}} als Gutschein aus.",
    outputCardAmount:
      "Der Betrag in der Höhe von {{moneyAmount}} wurde dem Konto des Kunden gutgeschrieben.",
    outputTipAmount:
      "Das Trinkgeld in der Höhe von {{moneyAmount}} wurde rückabgewickelt.",

    sendByMailDialogTitle: "Beleg per E-Mail versenden",
    sendCopy: "Beleg als Kopie senden",
    sendCopyOrPrint: "Beleg als Kopie drucken / senden",
    successSendMessage: 'Der Beleg wurde an "{{email}}" versendet.',

    refundDialogTitle: "Gutschrift erstellen",
    refundDialogMessage:
      "Es befindet sich noch ein Warenkorb in Bearbeitung. " +
      "Leeren Sie diesen zuerst oder schließen Sie diesen ab, bevor Sie eine Gutschrift erstellen.",
    refundDialogConfirmLabel: "Zum Warenkorb",

    cancelDialogTitle: "Beleg stornieren",
    cancelDialogMessage:
      "Möchten Sie diesen Beleg über {{moneyAmount}} wirklich stornieren?",
    cancelDialogConfirmLabel: "Stornieren",
    cancelTaskDialogMessage:
      "Führen Sie die Stornierung nun auf dem Kartenterminal durch.",
    successCancelMessage:
      "Der Beleg {{originalNumber}} wurde durch {{cancelNumber}} storniert.",
  },

  //  Cash flows

  CashFlowListScreen: {
    adminDefined: "Vordefiniert",
    managerDefined: "Benutzerdefiniert",
    predefinedTooltip:
      "Diese Geldbewegungen werden " +
      "Ihnen standardmäßig von MAX&BEN zur Verfügung gestellt " +
      "und können lediglich aktiv oder inaktiv gesetzt werden.",

    emptyListMessage:
      "Es wurden für diese Geldbewegungsart noch keine Geldbewegungen angelegt.",
    emptyManagerTableMessage:
      "Es wurden noch keine unternehmensspezifischen Geldbewegungen angelegt.",
    emptyAdminTableMessage:
      "Es wurden noch keine Geldbewegungen durch MAX&BEN angelegt.",
    emptyAdminScreenTableMessage:
      "Es wurden noch keine Geldbewegungen angelegt.",

    visibleOnMessage:
      'Die Geldbewegung "{{name}}" kann nun in der App verwendet werden.',
    visibleOffMessage:
      'Die Geldbewegung "{{name}}" kann nicht mehr in der App verwendet werden.',

    deleteDialogTitle: "Geldbewegung löschen",
    deleteDialogMessage:
      'Möchten Sie die Geldbewegung "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Geldbewegung "{{name}}" wurde erfolgreich gelöscht.',
  },

  // platform (web) - Payment methods

  PaymentMethodListScreen: {
    payments: "Bezahlungen",
    overpayment: "Überzahlung",
    cardPayment: "Kartenzahlung",
    openDrawer: "Kassenlade öffnen",

    visibleOnMessage:
      'Die Zahlungsart "{{name}}" kann nun in der App verwendet werden.',
    visibleOffMessage:
      'Die Zahlungsart "{{name}}" kann nicht mehr in der App verwendet werden.',

    deleteDialogTitle: "Zahlungsart löschen",
    deleteDialogMessage:
      'Möchten Sie die Zahlungsart "{{name}}" wirklich löschen?',
    successDeleteMessage:
      'Die Zahlungsart "{{name}}" wurde erfolgreich gelöscht.',
  },

  // platform (web) - Cash flows

  CashFlowAddScreen: {
    title: "Geldbewegung anlegen",
    enabledByDefault: "Standardmäßig verfügbar",
    usableForDeposit: "Einzahlung erlaubt",
    usableForDisbursal: "Auszahlung erlaubt",

    successAddMessage:
      'Die Geldbewegung "{{name}}" wurde erfolgreich angelegt.',
  },
  CashFlowEditScreen: {
    title: "Geldbewegung bearbeiten",

    successEditMessage:
      'Die Geldbewegung "{{name}}" wurde erfolgreich bearbeitet.',
  },
} as const
